/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {

  private redirectUri = new BehaviorSubject<string>(null);

  getUri(): Observable<string>
  {
    return this.redirectUri.asObservable();
  }

  next(uri: string): void
  {
     this.redirectUri.next(uri);
  }

  clear(): void
  {
    this.redirectUri.complete();

  }

}
